import type { TimelineQuery } from './baseApi';
import type { SeasonQuery, SportListKind, SportListQuery } from './types';

/** Stable cache identities owned by the Base module. Root keys are also the invalidation boundary for that resource. */
export const baseQueryKeys = {
  bootstrap: ['bootstrap'] as const,
  search: (query: string) => ['search', query] as const,
  sports: {
    root: ['sports'] as const,
    list: ['sports', 'list'] as const,
    detail: (id: string | undefined) => ['sports', 'one', id] as const,
  },
  sportLists: {
    root: ['sport-lists'] as const,
    list: (kind: SportListKind, query: SportListQuery) => ['sport-lists', kind, query] as const,
  },
  seasons: {
    root: ['seasons'] as const,
    list: (query: SeasonQuery) => ['seasons', 'list', query] as const,
    detail: (id: string | undefined) => ['seasons', 'one', id] as const,
  },
  locations: ['locations'] as const,
  reportSettings: ['reportSettings'] as const,
  audit: (action: string) => ['audit', action] as const,
  timeline: (query: TimelineQuery) => ['timeline', query] as const,
  apps: ['apps'] as const,
  backups: {
    root: ['backups'] as const,
    status: ['backups', 'status'] as const,
    history: ['backups', 'history'] as const,
  },
  systemChecks: ['system', 'checks'] as const,
  welcome: ['welcome'] as const,
  users: ['users'] as const,
  roles: ['roles'] as const,
};
